import { createAction, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxRootState } from "../../shared/redux/store";
import { ReduxSliceState } from "../../shared/types";
import { OrganizationItem } from "../../api/types";
import { ReduxOrgSwitcherState } from "../types";

const initialState: ReduxOrgSwitcherState = {
    organizationsState: 'READY',
    organizations: [],
    switchState: 'READY',
    lastSwitchedOrg: undefined,
};

// Org Switcher feature - loads the role-scoped org list (GET /organizations already returns
// every org sharing a User Group Manager's UserGroupId, see SecurityService.
// GetAppUserOrganizationsAsync) and reissues a token scoped to whichever org is picked.
export const loadSwitcherOrganizations = createAction('orgSwitcher/loadOrganizations');
export const switchOrg = createAction('orgSwitcher/switchOrg', (orgId: number) => ({ payload: { orgId } }));

const orgSwitcherSlice = createSlice({
    name: 'orgSwitcher',
    initialState,
    reducers: {
        setOrganizationsState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.organizationsState = action.payload;
        },
        setOrganizations: (state, action: PayloadAction<OrganizationItem[]>) => {
            state.organizations = action.payload;
        },
        setSwitchState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.switchState = action.payload;
        },
        setLastSwitchedOrg: (state, action: PayloadAction<OrganizationItem | undefined>) => {
            state.lastSwitchedOrg = action.payload;
        },
    },
});

export default orgSwitcherSlice;

const selectSelf = (state: ReduxRootState) => state.orgSwitcher;
export const selectSwitcherOrganizations = createSelector(selectSelf, self => self.organizations);
export const selectSwitcherOrganizationsIsBusy = createSelector(selectSelf, self => self.organizationsState === 'BUSY');
export const selectSwitcherIsBusy = createSelector(selectSelf, self => self.switchState === 'BUSY');
export const selectSwitcherLastSwitchedOrg = createSelector(selectSelf, self => self.lastSwitchedOrg);
